import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
} from "@windmill/react-ui";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useContext, useEffect } from "react";

import VendorServices from "services/VendorServices";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import { SidebarContext } from "context/SidebarContext";
import Somethingwentwrong from "pages/Somethingwentwrong";
import Loader from "components/form/Loader";
import VendorRequestTable from "components/vendor/VendorRequestTable";
import sidebar from "routes/sidebar";
import { FiRefreshCcw } from "react-icons/fi";

const VendorRequest = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { data, loading, error } = useAsync(VendorServices.getAllVendorRequest);
  const { functionLoading, setIsUpdate } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [status, setStatus] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchData, setSearchData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);


  const sourceData = isSearching
    ? searchData
    : Array.isArray(data?.data)
      ? data.data
      : [];

  const {
    vendorRequestRef,
    dataTable,
    serviceData,
    handleSubmitVendorRequest,
    currentPage,
  } = useFilter(sourceData, itemsPerPage);


  useEffect(() => {
    if (serviceData && serviceData.length > 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);


  const updatedData = Array.isArray(data?.data)
    ? data.data.map((item, index) => {
      // console.log("data in updatedata", item);

      return {
        "SI.No": index + 1,
        "Company Name": item.company_name,
        "Person Name": item.full_name,
        City: item.city_name,
        Address: item.address,
        "Employees Count": item.no_of_employees,
        "Fleet Count": item.no_of_fleet,
        "Added Date": item.added_date,
        "Company Age": item.company_age,
        "Contact Number": item.contact_no,
        "Vendor Reason": item.vendor_reason,
      };
    })
    : [];

  // console.log("data in updatedata", updatedData);

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "vendor enquiry list" && perm.view === 1
    );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
      (perm) => perm.id_tab === "vendor enquiry list" && perm.export === 1
    );

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  // const handleRefresh = () => {
  //   setIsUpdate(true);
  // };
  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  const handleRefresh = () => {
    if (vendorRequestRef?.current) {
      vendorRequestRef.current.value = "";
    }
    setSearchData([]);
    setIsUpdate(true);
  };

  const handleSearch = () => {
    const value = vendorRequestRef.current?.value
      ?.toLowerCase()
      .trim();

    if (!value) {
      setSearchData([]);
      setIsSearching(false);
      return;
    }

    setIsSearching(true);

    const filtered =
      data?.data?.filter((item, index) =>
        // (index + 1).toString().includes(value) ||
        item.company_name?.toLowerCase().includes(value) ||
        item.full_name?.toLowerCase().includes(value) ||
        item.city_name?.toLowerCase().includes(value)
      ) || [];

    setSearchData(filtered);
  };


  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />
          <MainDrawer>
            {/* <VendorRequestDrawer id={serviceId} /> */}
          </MainDrawer>
          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="gap-6 items-center flex">
                <div className="flex-1">
                  <Input
                    ref={vendorRequestRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSearch}
                  />
                </div>

                {hideExport && (
                  <ExportDataXlsx
                    exportDataXlsx={updatedData}
                    fileNames="Vendor Request"
                  />
                )}

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>
          {functionLoading && <Loader message="Please wait..." />}
          <DataWrapper loading={loading} error={error} status={status}>
            {sourceData?.length !== 0 ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                      <tr>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Company Name</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>City</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Action</TableCell>
                      </tr>
                    </TableHeader>
                    <VendorRequestTable
                      vendor={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {data.status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Vendors." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default VendorRequest;
